export default __webpack_public_path__ + "static/media/VJA-4.3168f69d.webp";